import {Usuari} from "../model/Usuari";

const apiUrl = process.env.REACT_APP_API_URL;
export const PutUsuari = async (usuari: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(usuari)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
